import useAssemblyForm from './useAssemblyForm';
import { Link } from 'react-router-dom';
import PropertyCombobox from 'components/PropertyCombobox';
import SearchableSelect from 'components/SearchableSelect';
import styles from './AssemblyForm.module.css';

export default function AssemblyForm() {
  const {
    form, loading, error, numberLoading, checkingUnits, unitsWarning, id, isEdit, checkUnitsForProperty,
    handleChange, handleSubmit, canSubmit,
  } = useAssemblyForm();

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>{isEdit ? 'Editar Asamblea' : 'Nueva Asamblea'}</h1>
          <p>{isEdit ? `Modificando asamblea #${id}` : 'Crear nueva asamblea en el sistema'}</p>
        </div>
        <Link to="/admin/asambleas" className="btn btn-secondary">
          <i className="fas fa-arrow-left" /> Volver
        </Link>
      </div>

      {error && <div className="alert alert-danger"><i className={`fas fa-circle-exclamation ${styles.iconoAlerta}`} />{error}</div>}

      <div className="card">
        <div className="card-header"><h2>Información de la asamblea</h2></div>
        <div className="card-body">
          <form onSubmit={handleSubmit} noValidate>
            <div className={styles.rejilla}>

              <div className="form-group">
                <label className="form-label">Conjunto / Propiedad *</label>
                {/* F-20: una asamblea no se cambia de conjunto al editarla (sus
                    asistencias y votos son de las unidades de ESE conjunto). */}
                <PropertyCombobox value={form.property_id} placeholder="Seleccione..." allowEmpty={false}
                  disabled={isEdit} params={{ sin_logistica: 1 }} minWidth={0} maxWidth={9999}
                  onChange={(id) => handleChange({ target: { name: 'property_id', value: id } })} />

                {/* ── Indicador de validación de unidades ── */}
                {form.property_id && !isEdit && (
                  <div className={styles.indicador}>
                    {checkingUnits && (
                      <div className={styles.verificando}>
                        <div className={`spinner ${styles.spinnerVerificando}`} />
                        Verificando unidades...
                      </div>
                    )}

                    {!checkingUnits && unitsWarning?.type === 'ok' && (
                      <div className={styles.estadoOk}>
                        <i className="fas fa-circle-check" />
                        {unitsWarning.total} unidades — todas tienen propietario asignado ✓
                      </div>
                    )}

                    {!checkingUnits && unitsWarning?.type === 'error' && (
                      <div className={styles.estadoError}>
                        <i className="fas fa-triangle-exclamation" />
                        No pudimos verificar las unidades de esta propiedad.
                        <button type="button" className="btn btn-sm btn-secondary" onClick={() => checkUnitsForProperty(form.property_id)}>
                          <i className="fas fa-rotate-right" /> Reintentar
                        </button>
                      </div>
                    )}

                    {!checkingUnits && unitsWarning?.type === 'no_buildings' && (
                      <div className={styles.estadoAviso}>
                        <i className="fas fa-triangle-exclamation" />
                        Esta propiedad no tiene torres registradas
                      </div>
                    )}

                    {!checkingUnits && unitsWarning?.type === 'no_units' && (
                      <div className={styles.estadoAviso}>
                        <i className="fas fa-triangle-exclamation" />
                        Esta propiedad no tiene unidades registradas
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">Número de Asamblea *</label>
                <input type="number" name="number_assembly" className="form-control"
                  value={numberLoading ? '' : form.number_assembly}
                  placeholder={numberLoading ? 'Calculando…' : (isEdit ? '' : 'Elige el conjunto primero')}
                  onChange={handleChange} readOnly={!isEdit} required />
                {!isEdit && (
                  <small className={styles.nota}>
                    Se asigna automáticamente — es el siguiente número para este conjunto.
                  </small>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">Fecha de creación *</label>
                <input type="datetime-local" name="date" className="form-control"
                  value={form.date} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label className="form-label">Quórum (%) *</label>
                <input type="number" name="quorum" className="form-control" min="0" max="100"
                  value={form.quorum} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label className="form-label">Tipo de Asamblea *</label>
                <SearchableSelect value={form.assembly_type} onChange={(v) => handleChange({ target: { name: 'assembly_type', value: v } })} minWidth={0} maxWidth={9999} allowEmpty={false} ariaLabel="Tipo de asamblea" options={[{ value: 'ordinaria', label: 'Ordinaria' }, { value: 'extraordinaria', label: 'Extraordinaria' }]} />
              </div>

              <div className="form-group">
                <label className="form-label">Modalidad *</label>
                {/* Con la asamblea en curso la modalidad no cambia (el servidor también lo rechaza). */}
                <SearchableSelect value={form.assembly_model} onChange={(v) => handleChange({ target: { name: 'assembly_model', value: v } })} disabled={isEdit && form.status === 'en_progreso'} minWidth={0} maxWidth={9999} allowEmpty={false} ariaLabel="Modalidad" options={[{ value: 'virtual', label: 'Virtual' }, { value: 'inplace', label: 'Presencial' }, { value: 'hybrid', label: 'Mixta' }]} />
                {isEdit && form.status === 'en_progreso' && (
                  <small className={styles.nota}>No se puede cambiar con la asamblea en curso.</small>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">Fecha de inicio *</label>
                <input type="datetime-local" name="start_date" className="form-control"
                  value={form.start_date} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label className="form-label">Fecha de finalización *</label>
                <input type="datetime-local" name="end_date" className="form-control"
                  value={form.end_date} onChange={handleChange} required />
              </div>

              <div className={`form-group ${styles.anchoCompleto}`}>
                <label className="form-label">Orden del día</label>
                <textarea name="orden_del_dia" className="form-control" rows="5"
                  placeholder={'Un punto por línea. Ej:\n1. Verificación del quórum\n2. Aprobación del acta anterior\n3. Informe de gestión'}
                  value={form.orden_del_dia} onChange={handleChange} maxLength={5000} />
                <div className={styles.notaOrden}>
                  Los propietarios lo ven en su panel durante la asamblea y precarga el acta.
                </div>
              </div>
            </div>

            {/* ── Alerta de unidades sin propietario ── */}
            {!isEdit && !checkingUnits && unitsWarning?.type === 'missing_owners' && (
              <div className={styles.alertaUnidades}>
                <div className={styles.alertaFila}>
                  <div className={styles.alertaIcono}>
                    <i className={`fas fa-user-xmark ${styles.alertaGlifo}`} />
                  </div>
                  <div className={styles.alertaCuerpo}>
                    <div className={styles.alertaTitulo}>
                      No puedes crear la asamblea
                    </div>
                    <div className={styles.alertaTexto}>
                      <strong>{unitsWarning.withoutOwner}</strong> de <strong>{unitsWarning.total}</strong> unidades
                      no tienen propietario asignado. Todas las unidades deben tener un propietario
                      antes de crear la asamblea.
                    </div>

                    {/* Tabla de unidades sin propietario */}
                    <div className={styles.tablaCaja}>
                      <div className={styles.tablaTitulo}>
                        Unidades sin propietario ({unitsWarning.withoutOwner})
                      </div>
                      <div className={styles.tablaLista}>
                        {unitsWarning.details.map((d, i) => (
                          <div key={i} className={i > 0 ? styles.unidadFilaConLinea : styles.unidadFila}>
                            <i className={`fas fa-door-open ${styles.unidadIcono}`} />
                            <span className={styles.unidadNombre}>Unidad <strong>{d.unit}</strong></span>
                            <span className={styles.unidadTorre}>{d.tower}</span>
                          </div>
                        ))}
                        {unitsWarning.truncated && (
                          <div className={styles.recortado}>
                            Se muestran las primeras {unitsWarning.details.length} de {unitsWarning.withoutOwner}.
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={styles.pista}>
                      <i className={`fas fa-info-circle ${styles.iconoPista}`} />
                      Ve a <strong>Propietarios → Importar</strong> para asignar propietarios a estas unidades.
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className={styles.acciones}>
              <button type="submit" className="btn btn-primary"
                disabled={loading || (!isEdit && !canSubmit)}>
                <i className={`fas ${loading ? 'fa-spinner fa-spin' : 'fa-save'}`} />
                {loading ? 'Guardando...' : isEdit ? 'Actualizar' : 'Crear asamblea'}
              </button>
              <Link to="/admin/asambleas" className="btn btn-secondary">Cancelar</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}